// import { data } from "autoprefixer";
import React, { useState, useEffect } from "react";
import { Row, Col, Form } from "react-bootstrap";
import Options from "../Options";
import parse from 'html-react-parser'
import "../../css/ChoiceQuestions.scss"
// import { Button, Collapse } from 'react-bootstrap';
import AnswerExplanation from "../../GradeSubmission/AnswerExplaination";
// import { renderToString } from 'react-dom/server';
import { removeRemarks } from "../../GradeSubmission/GradeCheck";
import log from "loglevel";

const ChoiceQuestion = ({ courseId, question, index, previousResponse, updateResponse, disable, Eval }) => {

  const [questionResponseId, setQuestionResponseId] = useState(null);
  const answerOptions = question.questionanswer_set?.map(answer => answer.answer_option);
  const checkedOptions = previousResponse.response_options_ids;
  let correct_answer;
  let sortedAnswerOptions = answerOptions.slice().sort();
  let sortedCheckedOptions = checkedOptions ? checkedOptions.slice().sort() : [];
  const arraysEqual = JSON.stringify(sortedAnswerOptions) === JSON.stringify(sortedCheckedOptions);
  log.log("checking answer  ", index, arraysEqual, answerOptions, checkedOptions, Eval, question.marks, question)
  var mode = localStorage.getItem("mode");
  
  useEffect(() => {
    log.log("previous Response is", { qrId: previousResponse })
    if (previousResponse && !questionResponseId) {
      setQuestionResponseId(previousResponse.id)
    }
  }, [previousResponse]);

  
  const updateChoices = async (options) => {
    log.log("good i reached here with options ", options);
    updateResponse(options);
  }
  const q_text = removeRemarks(question?.question_text)
  
  return (
    <Row className="choice-question" style={{ margin: 10 }}>
      <Col xs={12} style={{ marginBottom: 10 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '5px', borderBottom: '1px solid #ddd' }}>
          <b><i><span style={{ fontSize: 20, color: 'rgb(41, 121, 255)' }}>{`Question ${index + 1}`}</span></i></b>
          <span style={{ fontStyle: 'italic', fontWeight: 'bold', color: 'rgb(41, 121, 255)' }}>
            <i>Question Type: {question.question_type == 'S' ? 'SCQ' : question.question_type === "M" ? "MCQ" : ""} <span style={{ marginLeft: '40px' }}>Marks: {question.marks}</span></i>
          </span>
        </div>
      </Col>


      <Col xs={12} className="question-text">{parse(`${q_text}`)}</Col>

      <Col xs={12} className="options-wrapper">
        <Options
          courseId={courseId}
          question={question}
          otherLabId={question.otherlab}
          questionId={question.id}
          options={question.questionoption_set}
          questionType={question.question_type}
          previousResponse={previousResponse}
          updateResponse={updateChoices}
          disable={disable}
          Eval={Eval}
        />
      </Col>
      {(disable === true) ?
        <>
          <Col xs={6} />
          <Col xs={6}>
            <Form.Check>
              <Form.Label>Scored Marks</Form.Label>
              <Form.Control
                type="number"
                min='0'
                value={question?.questionresponse_set?.scored_marks || 0}
                step='0.1'
                disabled
              />
            </Form.Check>
            {(Eval || mode === "I") && (
              <div style={{ marginRight: '-100px', marginTop: '-40px', marginLeft: '-450px' }}>
                <AnswerExplanation explanation={question?.answer_explaination} />
              </div>
            )}
          </Col>
        </>
        :
        <></>
      }
    </Row>
  );
};

export default ChoiceQuestion;
